//      
                                              

export default (el         )           => ({
  x: el.scrollLeft,
  y: el.scrollTop,
});



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/use-droppable-publisher/get-scroll.js